import { api } from "../config/AxiosConfig";
import { Currency } from "../../models/Currency";
import { API_ROOT } from "./ApiUrlFormatter";
import { DisbursementAccountFundingType } from "../../models/DisbursementAccountFundingType";
import { AdjustmentType } from "../../models/AdjustmentType";
import { EmlReasonCode } from "../../models/EmlReasonCode";
import { AuthRequestDeclineReason } from "../../models/AuthRequestDeclineReason";


export const ReferenceApi = {
  getCurrencies: async () => {
    const response = await api.get<Currency[]>(`${API_ROOT}/reporthub/currencies`);
    return response;
  },
  
  getDisbursementAccountFundingTypes: async () => {
    const response = await api.get<DisbursementAccountFundingType[]>(`${API_ROOT}/reporthub/disbursementaccountfundingtypes`);
    return response;
  },

  getAdjustmentTypes: async () => {
      const response = await api.get<AdjustmentType[]>(`${API_ROOT}/reporthub/adjustmenttypes`);
    return response;
  },

  getEmlReasonCodes: async () => {
      const response = await api.get<EmlReasonCode[]>(`${API_ROOT}/reporthub/emlreasoncodes`);
    return response;
  },

    getAuthRequestDeclineReasons: async () => {
        const response = await api.get<AuthRequestDeclineReason[]>(`${API_ROOT}/reporthub/authrequestdeclinereasons`);
      return response;
  },
};
